module.exports = __webpack_public_path__ + "images/7429647cf19c3ac014f363ea982d71a5-logo.png";